module.exports = __webpack_public_path__ + "static/mobile-reg.f677eaf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile-reg.png
// module id = 524
// module chunks = 35783957827783